import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import {
  Input,
  Button,
  Spinner,
} from "reactstrap";

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";

import widgetRandomName from "../../../assets/images/icons-component/random.png";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, insideRef, insideSwitch, openOption, onUpdate } = props;
  const [RandonList, setRandonList] = useState<string[]>([]);
  const [ChooseList, setChooseList] = useState<string[]>([]);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [isFinish, setIsFinish] = useState<boolean>(false);
  const [ShowCOde, setShowCOde] = useState<string>("");
  const [randomBlock, setRandomBlock] = useState<boolean>(false);
  const [randomClass, setRandomClass] = useState<string>("");

  useEffect(() => {
    
  }, [RandonList, ChooseList]);

  useEffect(() => {
    if (config.data && config.data.nameList) {
      getNameList();
    }
  }, [config.data?.nameList]);

  useEffect(() => {
    if (config.data && config.data.remember) {
      if (config.data?.triggered) {
        if (config.data.remember.length) {
          const name = config.data.remember[config.data.remember.length - 1];
          randomstring(RandonList.length, RandonList.findIndex(e => e === name));
        } else {
          clearList();
        }
        delete config.data.triggered;
      }
      for (const target of ChooseList) {
        if (!config.data.remember.includes(target)) {
          setRandonList([ ...RandonList, target ]);
          const newArr = ChooseList.filter(item => item !== target);
          setChooseList(newArr);
          setIsFinish(false);
        } 
      }
    }
  }, [config.data?.remember]);

  useEffect(() => {
    if (insideSwitch) {
      getNameList();
      setChooseList([]);
      setIsFinish(false);
    }
  }, [insideSwitch]);

  // useEffect(() => {
  //   if (config.data && config.data.remember) {
  //     const data = config.data;
  //     data.remember = ChooseList;
  //     onUpdate({ id: config.id, data: {...data} });
  //   }
  // }, [ChooseList]);

  const processDuplicates = (array: string[]): string[] => {
    const countMap: { [key: string]: number } = {};
    const result: string[] = [];

    for (const str of array) {
      if (countMap[str] === undefined) {
        countMap[str] = 1;
        result.push(str);
      } else {
        const count = countMap[str];
        countMap[str]++;
        result.push(`${str}(${count})`);
      }
    }

    return result;
  };

  const getNameList = () => {
    const setArr = [ ...config.data.nameList ].map(item => item.length > 40? item.slice(1, 40) : item);
    const processedArray = processDuplicates(setArr);    
    setRandonList(processedArray);
  };

  const toNumber = (str: string) => {
    if (typeof str === "number") {
      return Number(str);
    } else {
      return Number(str.split("px")[0]);
    }
  };
  
  const startRandom = () => {    
    randomstring(RandonList.length);
  };

  const randomstring = (len: number, triggered=-1) => {
    let width = 0;
    let chosenids = 0;
    const finalChosenId = triggered === -1 ? Math.floor(Math.random() * (len)) : triggered;
    const maxCount = len >= 12? 12 : len;
    const frame = () => {
      if (width >= 12) {
        clearInterval(moving);
        setIsRunning(false);
        setRandomClass("");
        setShowCOde(RandonList[finalChosenId]);
        nameDelete(finalChosenId);
        setRandomBlock(false);
      } else if (width > 10) {
        chosenids = Math.floor(Math.random() * (len));
        setShowCOde(RandonList[chosenids]);
        setRandomClass("animatejumplast");
        width += 1;
      } else if (width > 6) {
        chosenids = Math.floor(Math.random() * (len));
        setShowCOde(RandonList[chosenids]);
        setRandomClass("animatejump3");
        width += 1;
      } else {
        setIsRunning(true);
        chosenids = Math.floor(Math.random() * (len));
        setShowCOde(RandonList[chosenids]);
        setRandomClass("animatejump");
        width += 1;
      }
    }
    const moving = setInterval(frame,250);
    if (triggered === -1) {
      if (config.data && config.data.remember) {
        const data = config.data;
        data.remember = [ ...ChooseList, RandonList[finalChosenId] ];
        onUpdate({ id: config.id, data: {...data} });
      }
      setTimeout(() => { namePut(finalChosenId) }, 3400)
    };
  };

  const namePut = (chosenids: any) => {
    setChooseList([ ...ChooseList, RandonList[chosenids] ]);
  };

  const nameDelete = (chosenids: any) => {
    const newList = [...RandonList];
    newList.splice(chosenids, 1);
    setRandonList(newList);
    if (RandonList.length === 1) {
      setIsFinish(true);
    }
  };

  const clearList = () => {
    setRandonList(config.data.nameList);
    setChooseList([]);
    setShowCOde("");
    setIsFinish(false);
  };

  return (
    <React.Fragment>
      <div style={{ height: '100%', width: '100%', position: 'absolute' }}>
        {config.data && config.data.nameList.length > 0? (
          <div className="componentCore  overflow-hidden" style={{ height: '100%', width: '100%' }}>
            <React.Fragment>
              <div className="random-box flex flex-col items-center justify-center">
                <div className="randomCode core-color">
                  <div className={`overflow-hidden ${isRunning? randomClass : ""}`}>{ShowCOde !== ""? ShowCOde : "..."}</div>
                </div>
                {!isFinish? (
                <div className="randaomBtn">
                  <Button
                    className="core-btn random-btn flex items-center justify-center rounded-circle events-none-inside focus-visible:outline-none font-semibold inline-flex flex-row justify-center items-center focus-visible:ring-red-500 h-12 w-12 p-3 focus-visible:ring-offset-[3px] focus-visible:ring-[3px] crs-btn-dark cursor-pointer rounded-full crs-btn-theme-accent1"
                    onMouseDown={() => {startRandom(); setRandomBlock(true);}}
                    disabled={randomBlock}
                    style={{fontSize: "1.5rem"}}
                    >
                      Go
                  </Button>
                </div>
              ) : (
                <div className="randaomBtn" style={{ bottom: "8px" }}>
                  <div className="text-center">
                    <span className="d-block mb-2">每位學生都已經輪到過</span>
                    <span className="crs-link cursor-pointer" onMouseDown={clearList}>清除列表並重新開始</span>
                  </div>
                </div>
              )}
              </div>
            </React.Fragment>
          </div>
        ) : (
          <div className="relative flex h-full flex-col items-center justify-center p-6 bg-screen  overflow-hidden" style={{ cursor: 'auto' }}>
            <div className="widget-head">
              <img className="widget-img-icon" src={widgetRandomName} alt="" />
            </div>
            <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">抽籤</p>
            <Button
              color="light"
              className={`ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold`}
              onClick={(e: any) => {openOption()}}
              data-interaction-target-type="false"
            >
              <div className="relative justify-center h-100 w-100">
                <span className="flex items-center justify-center w-100">
                  設定
                </span>
              </div>
            </Button>
          </div>
        )}
      </div>
      {username? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(Index);